import React,{useState, useEffect} from 'react'
import {useTranslation} from 'react-i18next';
import {Dropdown} from 'react-bootstrap';
import Cookies from "universal-cookie";
import {LANG_COOKIE} from '../../Constants'

export const DropdownLenguaje = () => {
  const [CurentLenguaje, setCurentLenguaje] = useState("1");
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    const cookies = new Cookies();
    cookies.remove(LANG_COOKIE,{path:"/"});
    cookies.set(LANG_COOKIE, t("CurrentLenguaje").toLowerCase() ,{path:"/"});

  }, [CurentLenguaje]);
  
    return (
        <Dropdown id="ddlLenguaje" value={CurentLenguaje} drop="left" className='border-skin-primary active:border-none focus:border-none border-none bg-skin-primary/30 rounded-md font-semibold hover:bg-skin-secondary/80 hover:text-skin-mainBG'>
        <Dropdown.Toggle variant="" className='font-semibold text-white' >
        {t("CurrentLenguaje")}
        </Dropdown.Toggle>

        <Dropdown.Menu >
            <Dropdown.Item as="button" className='hover:bg-skin-primary/30' onClick={async ()=>{i18n.changeLanguage("es");setCurentLenguaje(1);
        }} data-idculture="1" data-code="es-mx" >{t("Esp")}</Dropdown.Item>
            <Dropdown.Item as="button" className='hover:bg-skin-primary/30 ' onClick={async()=>{i18n.changeLanguage("en");setCurentLenguaje(2);
            }} data-idculture="2" data-code="en-us">{t("Eng")}</Dropdown.Item>
        </Dropdown.Menu>
        </Dropdown>

    );
}